module.exports = __webpack_public_path__ + "img/vps1.9adb15f.png";